import React from 'react' ;
import _ from 'lodash';
import CurrencyData from './currencies.json';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('SINGLE_CURRENCY_SELECTOR', LOG_LEVELS.DEBUG);
const currencyIdSelector = o => o.currencyCode
const DISTINCT_CURRENCIES = _.sortBy(_.uniqBy(CurrencyData, currencyIdSelector), currencyIdSelector);

class SingleCurrencySelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selection: {}
        };
        this.selectionChangeHandler = this.selectionChangeHandler.bind(this);
    }

    selectionChangeHandler(event) {
        const fieldName = this.props.fieldName;
        log.debug('selectionChangeHandler(): %s, ', fieldName, event);
        const newValue = event?.detail?.item?.value ?? '';
        log.debug('selectionChangeHandler(): %s, oldValue: %s, newValue: %s  ', fieldName, this.state.selection[fieldName], newValue);
        let selection = Object.assign({}, this.state.selection);
        selection[fieldName] = newValue;
        this.setState({ selection });
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(selection);
        }
    }

    render() {
        const currencyList = this.props.currencyList || DISTINCT_CURRENCIES;
        const optionsList = [
            { label: 'Select currency', value: '' },
            ...currencyList.map((currency) => ({
                label: currency.currencyCode,
                value: currency.currencyCode,
                selected: this.props.value === currency.currencyCode
            }))
        ];
        return (
            <SSelect
                inputId="currency-single-select"
                name="currency"
                onS-select={this.selectionChangeHandler}
                optionsList={optionsList}
                multiple={false}
                showSelectionCount={false}
            />
        );
    }
}


SingleCurrencySelector.defaultProps = {
    defaultValue: '',
    onChange: ()=>{},
    fieldName: 'currencyCode',
    value: ''
}

export default SingleCurrencySelector;
